// Module
var code = "<record-form-view fields=\"singleMachineMoveComponentController.formFields\" model=\"singleMachineMoveComponentController.model\" title=\"Move\" on-submit=\"singleMachineMoveComponentController.submit(formViewController)\" on-cancel=\"singleMachineMoveComponentController.cancel(formViewController)\"> </record-form-view> ";
// Exports
export default code;